module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aneck8-d8f848c39777e1090aa3d6962b9668d0.jpg";